jQuery(window).on('load', function () {
    var initialize = function () {
        $("#upload-file").find("input:file").change(function(){

            var file = this.files[0];
            var form = $("#file-upload-form");
            var data = form.serializeArray();

            if(form.find("input[name='title']").val().length > 0 && form.find("textarea[name='description']").val().length > 0 && form.find("input[name='origin']").val().length > 0) {
                var formData = new FormData();
                formData.append('file', file);
                formData.append('id', form.attr('data-id'));
                formData.append('entity', form.attr('data-entity'));
                formData.append('origin', data[0].value);
                formData.append('storage', form.attr('data-storage'));
                formData.append('title', data[1].value);
                formData.append('description', data[2].value);
                var refresh = form.attr('data-refresh-page');
                if(form.attr('data-spinner') !== 'undefined') {
                    // $('.eval-image-container[data-key="' + form.attr('data-spinner') + '"]').LoadingOverlay("show",
                    //     {
                    //         image: $('body').attr('data-base-url') + "assets/img/loading.png",
                    //         imageAnimation: '2500ms rotate_left',
                    //         zIndex: 1005,
                    //         background: "rgb(250, 250, 250)"
                    //     }
                    // );
                }
                // uploadFile(formData, refresh);
                uploadListingFile(formData, refresh);
            } else {
                Materialize.toast('Please fill in all required fields!', 2000);
                form.find("input[type='file']").val('');
                form.find("input[type='uploaded-file-url']").val('');
            }
        });

        $('.update-file-button').click(function(e){
            e.preventDefault();

            var form = $('#file-update-form');

            if(form.find("input[name='title']").val().length > 0 && form.find("textarea[name='description']").val().length > 0) {
                var data = form.serializeArray();
                // updateFileInformation(data);
                updateListingFileInfo(data);
            } else {
                Materialize.toast('Please fill in all required fields!', 2000);
            }
        });
    };

    var initializeButtons = function() {
        $('.remove-attachment').click(function(e){
            e.preventDefault();
            var data = {
                'fileId' : $(this).attr('data-id'),
                'listingId' : $(this).attr('data-listing-id'),
                'entityName' : $(this).attr('data-entity-name')
            };

            deleteConfirm(removeListingFile, data);
        });

        $('.update-attachment').click(function(e){
            e.preventDefault();
            var modal = $('#edit-upload-file');
            var $this = $(this);

            var id = modal.find("input[name='id']");
            id.val($this.attr('data-id'));
            id.focusin();

            var title = modal.find("input[name='title']");
            title.val($this.attr('data-title'));
            title.focusin();

            var description = modal.find("textarea[name='description']");
            description.val($this.attr('data-description'));
            description.focusin();

            modal.modal('open');
        });
    };

    var removeListingFile = function(form){
        var data = null;
        if($(form).is('form')) {
            data = $(form).serializeArray();
        } else {
            data = form;
        }

        $.ajax({
            type: 'POST',
            url: $('body').attr('data-base-url') + 'listingfile/delete',
            data: data,
            success: function (responseTxt) {
                var response = JSON.parse(responseTxt);

                if(response.status === 'success') {
                    TableController.Files.refresh();
                }
            }
        });
    };
    var removeFile = function(form){
        var data = null;
        if($(form).is('form')) {
            data = $(form).serializeArray();
        } else {
            data = form;
        }

        $.ajax({
            type: 'POST',
            url: $('body').attr('data-base-url') + 'files/delete',
            data: data,
            success: function (responseTxt) {
                var response = JSON.parse(responseTxt);

                if(response.status === 'success') {
                    TableController.Files.refresh();
                }
            }
        });
    };

    var updateListingFileInfo = function(data){
        $.ajax({
            type: 'POST',
            url: $('body').attr('data-base-url') + 'listingfile/update',
            data: data,
            success: function (responseTxt) {
                var response = JSON.parse(responseTxt);

                if(response.success){
                    $("#edit-upload-file").modal('close');
                    TableController.Files.refresh();
                }
            }
        });
    };
    var updateFileInformation = function(data){
        $.ajax({
            type: 'POST',
            url: $('body').attr('data-base-url') + 'files/update',
            data: data,
            success: function (responseTxt) {
                var response = JSON.parse(responseTxt);

                if(response.success){
                    $("#edit-upload-file").modal('close');
                    TableController.Files.refresh();
                }
            }
        });
    };

  
    var uploadListingFile = function(formData, refresh) {
     

        $('#extra_image_upload_section').hide();
        $.ajax({
            type: 'POST',
            url: $('body').attr('data-base-url') + 'listingfile/post',
            data: formData,
            contentType: false,
            processData: false,
            xhr: function () {
                var xhr = new XMLHttpRequest();
                xhr.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = evt.loaded / evt.total;
                        percentComplete = parseInt(percentComplete * 100);
                        $('#show_extra_image_upload_progress').show();
                        $('#extra_image_progress').css('background-color','#7dcce1');
                        $('#extra_image_progress').text(percentComplete + '%');
                        $('#extra_image_progress').css('width', percentComplete + '%');

                    }
                }, false);
                return xhr;
            },
            success: function (responseTxt) {
                var response = JSON.parse(responseTxt);

                if(response.success){
                    $('#show_extra_image_upload_progress').hide();
                    //Closing model
                    $("#upload-file").modal('close');
                    //Reset form
                    $("#file-upload-form")[0].reset();
                    //Update files table
                    TableController.Files.refresh();

                    if(refresh) {
                        location.reload();
                    }
                }
            }
        }).done(function() {
            $('#file-upload-form').LoadingOverlay("hide");
        });
    };
    var uploadFile = function(formData, refresh) {
        // $('#file-upload-form').LoadingOverlay("show",
        //     {
        //         image: $('body').attr('data-base-url') + "assets/img/loading.png",
        //         imageAnimation: '2500ms rotate_left',
        //         zIndex: 1005,
        //         background: "rgb(250, 250, 250)"
        //     }
        // );

        $('#extra_image_upload_section').hide();
        $.ajax({
            type: 'POST',
            url: $('body').attr('data-base-url') + 'files/post',
            data: formData,
            contentType: false,
            processData: false,
            xhr: function () {
                var xhr = new XMLHttpRequest();
                xhr.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = evt.loaded / evt.total;
                        percentComplete = parseInt(percentComplete * 100);
                        $('#show_extra_image_upload_progress').show();
                        $('#extra_image_progress').css('background-color','#7dcce1');
                        $('#extra_image_progress').text(percentComplete + '%');
                        $('#extra_image_progress').css('width', percentComplete + '%');

                    }
                }, false);
                return xhr;
            },
            success: function (responseTxt) {
                var response = JSON.parse(responseTxt);

                if(response.success){
                    $('#show_extra_image_upload_progress').hide();
                    //Closing model
                    $("#upload-file").modal('close');
                    //Reset form
                    $("#file-upload-form")[0].reset();
                    //Update files table
                    TableController.Files.refresh();

                    if(refresh) {
                        location.reload();
                    }
                }
            }
        }).done(function() {
            $('#file-upload-form').LoadingOverlay("hide");
        });
    };

    if (window.FilesController === undefined) {
        window.FilesController = {};
    }

    initialize();

    window.FilesController = {
        initialize: initialize,
        initializeButtons: initializeButtons
    };
});


